var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0L31.7079 18.669L38.8427 1.33282L34.9719 19.6758L46.8996 5.21284L37.7941 21.6L53.4549 11.2953L39.9238 24.2705L57.9262 19.0398L41.1717 27.4501L59.9161 27.7581L41.4269 30.8563L59.2478 36.6756L40.6669 34.1864L55.9808 45L38.959 37.1446L50.4052 51.9916L36.4551 39.4679L43.0165 57.0291L33.3776 40.9499L34.4713 59.6649L30 41.459L25.5287 59.6649L26.6224 40.9499L16.9835 57.0291L23.5449 39.4679L9.59482 51.9916L21.041 37.1446L4.01924 45L19.3331 34.1864L0.752163 36.6756L18.5731 30.8563L0.0838852 27.7581L18.8283 27.4501L2.07379 19.0398L20.0762 24.2705L6.54506 11.2953L22.2059 21.6L13.1004 5.21284L25.0281 19.6758L21.1573 1.33282L28.2921 18.669L30 0Z",
    fill: "url(#paint0_linear_64_871)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_871",
    x1: 56.087,
    y1: 30,
    x2: 2.86957,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9260"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b2192e3ba758cfdab7cca3f74b87e66f.svg";
export { ForwardRef as ReactComponent };